import React, {useEffect, useCallback, useContext, useState} from 'react';
import Acknowledge from '../components/setAlert/acknowledge';
import Info from '../components/setAlert/info';
import CommandsContext from '../context/commandsContext';
import {useTranslation} from 'react-i18next';

export const generateAlertsChildren = (items, alert) => {
    const newItems = [...items];
  const alertsChildren = alert
    ? [
        {id: 112, name: 'Sensor Failed', component: <Info />},
        {id: 113, name: 'Acknowledge All Alerts', component: <Acknowledge />},
      ]
    : [{id: 11, name: 'No active alerts'}];

  const alerts = newItems.find(item => item.isAlert);
  alerts.children = alertsChildren;

  return [newItems, alerts]; 
};

export const findParent = (parent, list, selected) => {
  for (const item of list) {
    if (item.id === selected.id) {
      return parent;
    }

    if (item.children) {
      const parent = findParent(item, item.children, selected);
      if (parent) {
        return parent;
      }
    }
  }

  return null;
};

export const findParent2 = (parent, list, selected) => {
  for (const item of list) {
    if (item.id === selected.id) {
      return parent;
    }

    if (item.children) {
      const parent = findParent2(item, item.children, selected);
      if (parent) {
        return parent;
      }
    }
  }

  return null;
};

export const findList = (list, toFind) => {
  const item = list.find(item => item.id === toFind.id);

  if (item) return list;

  for (const item of list) {
    if (item.children) {
      const newList = findList(item.children, toFind);
      if (newList) {
        return newList;
      }
    }
  }

  return null;
};

export const findList2 = (list2, toFind) => {
  const item2 = list2.find(item2 => item2.id === toFind.id);

  if (item2) return list2;

  for (const item2 of list2) {
    if (item2.children) {
      const newList2 = findList2(item2.children, toFind);
      if (newList2) {
        return newList2;
      }
    }
  }

  return null;
};

export const useCommonMenu = ({
  onNext,
  selected,
  setSelected,
  items,
  list,
  disableMenu,
  onComponent,
  onUpCallback,
  onRightCallback,
  onDownCallback,
  onLeftCallback,
}) => {
  const {onUpdateCommands} = useContext(CommandsContext);
  const [tapCount, setTapCount] = useState(0);

  const onUp = useCallback(() => {
    setTapCount(0);
    if (disableMenu) return;

    if (onUpCallback) {
      onUpCallback(selected);
      return;
    }

    const index = list.findIndex(item => item.id === selected?.id);
    const nextItem = list[index - 1];
    if (!nextItem) {
      return;
    }
    setSelected(nextItem);
  }, [disableMenu, list, selected, items]);

  const onDown = useCallback(() => {
    setTapCount(0);
    if (disableMenu) return;

    if (onDownCallback) {
      onDownCallback(selected);
      return;
    }

    const index = list.findIndex(item => {
      return item.id === selected?.id;
    });
    const nextItem = list[index + 1];
    if (!nextItem) {
      return;
    }

    setSelected(nextItem);
  }, [disableMenu, list, selected, items]);

  const onLeft = useCallback(() => {
    setTapCount(0);
    if (disableMenu) return;

    if (list.length === 0) {
      return;
    }

    const parent = findParent(null, items, selected);
    if (!parent) {
      // onPrevious?.();
      if (onLeftCallback) {
        onLeftCallback(selected);
      }
      return;
    }

    if (onLeftCallback) {
      onLeftCallback(selected);
      return;
    }

    setSelected(parent);
  }, [disableMenu, list, selected, items]);

  const onRight = useCallback(() => {
    if (disableMenu) return;

    if (list.length === 0) {
      onNext();
    }

    if (selected?.component) {
      onComponent(selected.component);
      return;
    }

    if (!selected?.children && !selected?.component) {
      if (tapCount === 0 && selected.requireDoubleRight) {
        setTapCount(1);
        return;
      }

      const parent = findParent(null, items, selected);

      if (tapCount === 1) {
        setTapCount(2);
      }

      if (onRightCallback) {
        onRightCallback(selected);
        return;
      }
      setSelected(parent);
      return;
    }

    setSelected(selected.children[0]);
  }, [disableMenu, list, selected, items, tapCount]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({
        onUp,
        onDown,
        onRight,
        onLeft,
        onUpOverride: onUpCallback && (() => onUpCallback(selected)),
        onRightOverride: onRightCallback && (() => onRightCallback(selected)),
        onDownOverride: onDownCallback && (() => onDownCallback(selected)),
        onLeftOverride: onLeftCallback && (() => onLeftCallback(selected)),
      });
    });
  }, [onUp, onDown, onRight, onLeft, selected]);

  return React.useMemo(
    () => ({
      onUp,
      onDown,
      onRight,
      onLeft,
      tapCount,
    }),
    [onUp, onDown, onRight, onLeft, tapCount],
  );
};
